import Vue from "vue";

import { JobPollingService } from "@/services/jobPollingService";

declare module "vue/types/vue" {
  interface Vue {
    $jobPolling: JobPollingService;
  }
}

const jobPolling = JobPollingService.instance;

Vue.prototype.$jobPolling = jobPolling;

export default jobPolling;
